























































import { Component, Vue } from "vue-property-decorator";
import NavIcon from "./navigation/NavIcon.vue";
import { AuthModule } from "@/store/auth.module";
import { AuthService } from "@/services/auth.service";

@Component({
  components: {
    NavIcon,
  },
})
export default class ApNavigation extends Vue {
  dialogShow: boolean = false;
  // User info
  get isLoggedIn() {
    return AuthModule.isLoggedIn;
  }
  get user() {
    return AuthModule.user as IUser;
  }
  get userOrgName() {
    if (this.user.name && this.user.name.length >= 100) {
      const slice = this.user.name ? this.user.name.slice(0, 97) : "";
      return slice + "...";
    }
    return this.user.name;
  }

  goToContracts() {
    this.$router.push("/contracts");
  }

  logout() {
    AuthService.logout();
  }

  async created() {
    await this.$router.push("/contracts");
  }
}
